module.exports = __webpack_public_path__ + "static/media/P200_Tip_Box.500d93e0.svg";